import { getStorage } from "../utils/common/StorageController";
import { httpService } from "./Api";

class AppGalleryService {

    getLoginID() {
        return getStorage("loginUserID");
      }

      signIn(payLoad) {
        return httpService.post("userSignin", payLoad);
      }
      signUp(payLoad){
        return httpService.post("userSignup",payLoad)
      }
}

export const appGalleryService = new AppGalleryService();